import './ProgressBar.css';

export const ProgressBar = ({ percentage = 0, color = '#207DE9', className = '' }) => {
  return (
    <div className={`progress-bar ${className}`.trim()}>
      <div 
        className="progress-bar__fill" 
        style={{ 
          width: `${percentage}%`,
          backgroundColor: color
        }}
      />
    </div>
  );
};

